import getIntervalChangedType, { IntervalChangedType } from './getIntervalChangedType';
import { addMinutes, isBefore, OwaDate, subMinutes, differenceInMinutes } from 'owa-datetime';
import {
    getDefaultShouldShortenEventDurationStartLate,
    getDefaultEndShortEventsBy,
    getDefaultEndLongEventsBy,
} from 'owa-calendar-cloud-settings';

/**
 * Update the event start time when the 'Shorten events duration' setting is on
 * @param previousStart
 * @param previousEnd
 * @param newStart
 * @param newEnd
 */
export default function getConfiguredEventStartTimeBasedOnPreviousInterval(
    previousStart: OwaDate,
    previousEnd: OwaDate,
    newStart: OwaDate,
    newEnd: OwaDate,
    useNewStartAsPrevious?: boolean,
    ignoreZeroDuration?: boolean
): OwaDate {
    if (!getDefaultShouldShortenEventDurationStartLate()) {
        return newStart;
    }

    const previousDuration = differenceInMinutes(previousEnd, previousStart);
    const newDuration = differenceInMinutes(newEnd, newStart);
    const intervalChangedType = getIntervalChangedType(previousDuration, newDuration);

    const previousStartTime = useNewStartAsPrevious ? newStart : previousStart;
    let updatedStartTime = newStart;

    if (intervalChangedType === IntervalChangedType.ShortToLong) {
        updatedStartTime = addMinutes(
            subMinutes(previousStartTime, getDefaultEndShortEventsBy()),
            getDefaultEndLongEventsBy()
        );
    } else if (intervalChangedType === IntervalChangedType.LongToShort) {
        updatedStartTime = addMinutes(
            subMinutes(previousStartTime, getDefaultEndLongEventsBy()),
            getDefaultEndShortEventsBy()
        );
    } else if (intervalChangedType === IntervalChangedType.ZeroToShort && !ignoreZeroDuration) {
        updatedStartTime = addMinutes(previousStartTime, getDefaultEndShortEventsBy());
    } else if (intervalChangedType === IntervalChangedType.ZeroToLong && !ignoreZeroDuration) {
        updatedStartTime = addMinutes(previousStartTime, getDefaultEndLongEventsBy());
    }

    if (isBefore(updatedStartTime, newEnd)) {
        return updatedStartTime;
    }

    return newStart;
}

export function getConfiguredEventStartTimeBasedOnPreviousIntervalWithDuration(
    previousStart: OwaDate,
    previousEnd: OwaDate,
    newDuration: number
): OwaDate {
    if (!getDefaultShouldShortenEventDurationStartLate()) {
        return previousStart;
    }

    const previousDuration = differenceInMinutes(previousEnd, previousStart);
    const intervalChangedType = getIntervalChangedType(previousDuration, newDuration);

    let updatedStartTime = previousStart;
    if (intervalChangedType === IntervalChangedType.ShortToLong) {
        updatedStartTime = addMinutes(
            subMinutes(previousStart, getDefaultEndShortEventsBy()),
            getDefaultEndLongEventsBy()
        );
    } else if (intervalChangedType === IntervalChangedType.LongToShort) {
        updatedStartTime = addMinutes(
            subMinutes(previousStart, getDefaultEndLongEventsBy()),
            getDefaultEndShortEventsBy()
        );
    }

    return updatedStartTime;
}
